import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "bg-white px-2 py-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "title-1" }, "Foire aux questions", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Retour à la page de connexion ")
const _hoisted_4 = { class: "d-flex flex-col gap-2 mx-auto" }
const _hoisted_5 = { class: "title-4" }
const _hoisted_6 = { key: 0 }

import { request } from "@/domains/api/api";
import { Faq } from "../faqs";
import { useUser } from "@/domains/auth/user";
import { RouterLink } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  async setup(__props) {

let __temp: any, __restore: any

const questions = (
  ([__temp,__restore] = _withAsyncContext(() => request<Faq[]>("faqs", "get"))),
  __temp = await __temp,
  __restore(),
  __temp
);
const { user } = useUser();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (!_unref(user))
      ? (_openBlock(), _createBlock(_unref(RouterLink), {
          key: 0,
          to: { name: 'auth.login' },
          class: "mb-3 d-block text-center"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(questions), (question) => {
        return (_openBlock(), _createElementBlock("li", {
          key: question.id
        }, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(question.question), 1),
          _createElementVNode("p", null, _toDisplayString(question.answer), 1)
        ]))
      }), 128)),
      (!_unref(questions))
        ? (_openBlock(), _createElementBlock("li", _hoisted_6, "Aucune FAQ n'a été rédigée pour le moment"))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})